import './globals'
import './dependencias'
import './index.css'
import React from 'react';
import ReactDOM from 'react-dom/client';
import { LoaderProvider } from './hooks/useLoader';
import { ToastContainer } from 'react-toastify';
import { SistemaProvider } from './hooks/useSistema';
import { LoginOrApp } from './main/LoginOrApp';
import { toastifyConfig } from './consts';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <LoaderProvider>
    <ToastContainer {...toastifyConfig} />
    <SistemaProvider>
      <LoginOrApp />
    </SistemaProvider>
  </LoaderProvider>,
  // </React.StrictMode>
)
